import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import { CreateCrtPeriodDetailsDialog } from '@/components/CreateCrtPeriodDetailsDialog'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import { rapForecastsSearchSchema, useCreateRapForecast } from '@/hooks/queries/crt/useRapForecasts'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import RapForecastsDataTable from './-components/RapForecastsDataTable'

export const Route = createFileRoute(
  '/_auth/_modules/crt/customer-investments/data-sources/rap-forecasts/',
)({
  component: RouteComponent,
  validateSearch: (search) => rapForecastsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')
  const search = Route.useSearch()
  const [isOpen, setIsOpen] = useState(false)

  const { isPending, mutate } = useCreateRapForecast({
    queries: search,
    handleOnSuccess: () => setIsOpen(false),
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('rapForecasts.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_rap_forecasts_create']}>
          <CreateCrtPeriodDetailsDialog
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            triggerLabel={t('rapForecasts.createButton')}
            title={t('createRapForecastDialog.title')}
            nameLabel={t('createRapForecastDialog.name.label')}
            namePlaceholder={t('createRapForecastDialog.name.placeholder')}
            isPending={isPending}
            onSubmit={({ name, description, crtPeriod }) =>
              mutate({ name, description, crtPeriod })
            }
          />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardHeader>
          <CardTitle>{t('rapForecasts.cardTitle')}</CardTitle>
        </CardHeader>

        <CardContent>
          <VStack gap="md">
            <RapForecastsDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
